module.exports = __webpack_public_path__ + "img/img_manual1_1.884d543b.jpg";